package com.macrofocus.nastac.components

import ch.ethz.nastac.server.BuildKonfig
import com.macrofocus.nastac.Sizes
import com.macrofocus.nastac.theme.ThemeContext
import csstype.*
import emotion.react.css
import mui.material.PaletteMode
import mui.material.TooltipPlacement
import mui.system.Box
import mui.system.sx
import react.*
import react.dom.html.ReactHTML
import web.cssom.*

val SidebarContent = FC<Props> {
    val DEBUG = false

    var theme by use(ThemeContext)!!
    val nastac = use(NASTACContext)!!

    Box {
        sx {
            width = Sizes.Sidebar.Width
            display = Display.inlineFlex
            justifyContent = JustifyContent.center
        }

        Logo {
//                sx { width = Sizes.Sidebar.Width }

            version = BuildKonfig.nastacVersion
            logo = if (theme.palette.mode == PaletteMode.light) "/eth_logo_kurz_pos.svg" else "/eth_logo_kurz_neg.svg"
            height = 54.0
            marginLeft = -12.px
        }
    }

    mui.material.Tooltip {
        title = ReactNode("This project has received funding from the European Research Council (ERC) under the European Union’s Horizon 2020 research and innovation programme (ERC Advanced Grant agreement No.787478 NASTAC)")
        placement = TooltipPlacement.bottomEnd

        ReactHTML.img {
//            if(props.marginLeft != null) {
                css {
                    marginLeft = 100.px
                }
//            }
            src = "/LOGO_ERC-FLAG_EU.svg"
            height = 36.0
        }
    }


    Box {
        sx {
            display = Display.inlineFlex
            marginLeft = 10.px
        }

//        DateChooser {
//            timeTracker = diviso.configuration.timeTracker
//        }
    }

    Box {
        sx {
            width = 100.pct
            height = 185.px
        }

        ViewStyleLinks {
            this.viewStyle = nastac.dataLoader.viewStyle
        }
    }

    Box {
        sx {
            display = Display.inlineFlex
            marginLeft = 10.px
        }

        TimeSlider {
            this.shiftValue = nastac.dataLoader.shiftValue
            this.localShiftValue = nastac.dataLoader.localShiftValue
            this.minYear = nastac.dataLoader.minYear
            this.maxYear = nastac.dataLoader.maxYear

//            timeTracker = diviso.configuration.timeTracker
//            timeUnitChooser = false
//            valueLabelDisplay = "off"
//            width = 210.px
        }
    }
}